/**
 * @module Experince/Shop/Shipping-Information
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';

// Interface
import { ShippingLandingModel } from '@experience/shop/cart/modules/shipping/models/shipping-landing.model';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { Address } from '@support/api/proxies/responses/api-2004.interface';
import { ObjectInterface } from '@support/api/common/api-response.interface';

@Component({
  selector: 'tmo-order-confirmation-shipping-information',
  templateUrl: './shipping-information.component.html',
})
export class ShippingInformationComponent implements OnInit, OnDestroy {
  /**
   * Stores the content coming from AEM call
   */
  @Input() public shippingAemContent: ObjectInterface;
  /**
   * variable to hold order response
   */
  public shippingModel: ShippingLandingModel;

  public shippingAddress: Address;
  /**
   * stores values of back order status
   */
  @Input() public backOrderStatus: boolean;
  /**
   * Variable to unsubscribe all the subscribers
   */
  private ngUnsubscribe: Subject<void>;

  constructor(private stateStoreUtilService: StateStoreUtilsService) {
    this.ngUnsubscribe = new Subject<void>();
  }

  /**
   * Loads the initial configuration of shipping information component
   * @returns void
   */
  public ngOnInit(): void {
    this.shippingModel = this.stateStoreUtilService.getShippingModel();
    this.shippingAddress = this.shippingModel && this.shippingModel.selectedShippingAddress;
  }

  /**
   * Method to destroy service data.
   * @returns void
   */
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
